import React from "react";
import { Text, View, StyleSheet, TouchableOpacity } from "react-native";
import CustomIcon from "../components/CustomIcon";
import { useNavigation } from "@react-navigation/native";

export default function InviteWebHeader() {
  const navigation = useNavigation();
  return (
    <View style={styles.inviteHeadertContainer}>
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={() => navigation.navigate("InviteFriends")}>
        <View style={styles.inviteHeadertContainer}>
          <View style={styles.optionIconContainer}>
            <CustomIcon
              name="icon-friends"
              size={26}
              color="#30829E"
            />
          </View>
          <View style={styles.invitetextContainer}>
            <Text style={styles.optionText}>Invite Friends</Text>
          </View>
          <View style={styles.optionPromo}>
            <Text style={styles.optionPromoText}>$5</Text>
          </View>
        </View>
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  optionPromo: {
    left: 20,
    alignSelf: "center",
    height: 32,
    width: 32,
    borderRadius: 25,
    backgroundColor: "#ffffff",
  },
  optionIconContainer: {
    alignSelf: "center",
    marginRight: 12,
  },
  optionPromoText: {
    alignSelf: "center",
    paddingTop: 8,
    color: "#30829E",
    fontFamily: "montserrat-medium",
    fontSize: 16,
  },
  optionText: {
    alignSelf: "flex-start",
    color: "#30829E",
    fontFamily: "montserrat-medium",
    fontSize: 16,
  },
  inviteButtonContainer: {
    flex: 1,
    flexDirection: "row",

  },
  inviteHeadertContainer: {
    flex: 1,
    flexDirection: "row",
    paddingRight: 40,
    justifyContent:"flex-end",
    marginBottom: 10,
  },
  invitetextContainer: {
    alignSelf: "center",
  }
})